import { render, staticRenderFns } from "./Hotplace.vue?vue&type=template&id=f6d0ba88&scoped=true"
import script from "./Hotplace.vue?vue&type=script&lang=js"
export * from "./Hotplace.vue?vue&type=script&lang=js"
import style0 from "./Hotplace.vue?vue&type=style&index=0&id=f6d0ba88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d0ba88",
  null
  
)

export default component.exports